export const NOT_TRACKED_CONTENT = '<not tracked>';
